export const BackdropClassEnum = {
  SLIDE: "slide",
  CAROUSEL_ROOT: "carousel-root",
  CAROUSEL_MODAL: "carousel-modal"
};
